import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-rsvn',
  templateUrl: './header-rsvn.component.html',
  styleUrls: ['./header-rsvn.component.scss']
})
export class HeaderRsvnComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
